import { render, staticRenderFns } from "./BranchEdit.vue?vue&type=template&id=2fd9b638&scoped=true"
import script from "./BranchEdit.vue?vue&type=script&lang=js"
export * from "./BranchEdit.vue?vue&type=script&lang=js"
import style0 from "./BranchEdit.vue?vue&type=style&index=0&id=2fd9b638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd9b638",
  null
  
)

export default component.exports